import React from 'react';
import '../styles/HowItWorks.css';

const HowItWorks: React.FC = () => {
  return (
    <div className="how-it-works-container">
      <h1>How It Works?</h1>
      <p className="subtitle">
        Secure and Verifiable token contract
        <span className="external-link-icon">&#8599;</span>
      </p>

      <div className="no-statements">
        <p><span className="no">No</span> <span className="no-statements-text">presale</span></p>
        <p><span className="no">No</span> <span className="no-statements-text">team allocation</span></p>
        <p><span className="no">No</span> <span className="no-statements-text">insiders</span></p>
      </div>

      <div className="steps-diagram">
        <svg viewBox="0 0 1000 200" className="steps-svg">
          <path d="M100,120 Q250,30 400,100 T700,90 T900,120" className="path" />
          <circle cx="100" cy="100" r="50" className="step-circle active" />
          <circle cx="300" cy="100" r="50" className="step-circle" />
          <circle cx="500" cy="100" r="50" className="step-circle active" />
          <circle cx="700" cy="100" r="50" className="step-circle" />
          <circle cx="900" cy="100" r="50" className="step-circle active" />
          <text x="100" y="105" className="step-number">I</text>
          <text x="300" y="105" className="step-number">II</text>
          <text x="500" y="105" className="step-number">III</text>
          <text x="700" y="105" className="step-number">IV</text>
          <text x="900" y="105" className="step-number">V</text>
        </svg>
      </div>

      <div className="steps-description">
        <div className="step">
          <p className="step-title">Step 1</p>
          <p>Pick a Game you wish to support or a Game to speculate on.</p>
        </div>
        <div className="step">
          <p className="step-title">Step 2</p>
          <p>Buy the Game Token on the bonding curve after it's released.</p>
        </div>
        <div className="step">
          <p className="step-title">Step 3</p>
          <p>Sell tokens at any time to lock in your profits or losses.</p>
        </div>
        <div className="step">
          <p className="step-title">Step 4</p>
          <p>When market cap of $69,420 is reached, trading is halted.</p>
        </div>
        <div className="step">
          <p className="step-title">Step 5</p>
          <p>Token is transferred to G7 Swap, 10% of Supply is Burned.</p>
        </div>
      </div>

      <div className="buttons-container">
        <p>
          ALL Weirdly trading fees are reserved for the Developers of the Games listed in Weirdly.
          When you trade a games token, you support game developers.
          Access to the fee reserve is automatic when a developer claims their game.
          Game developers who want to make more $$ on trading fees can advertise their games token =)
        </p>
      </div>
    </div>
  );
};

export default HowItWorks;